/*
 * @Author: wangdong
 * @Date: 2022-02-23 10:55:54
 * @Last Modified by: wangdong
 * @Last Modified time: 2022-03-15 10:52:55
 * @description 服务域名以为是本地写死的常量，最后场景需要通过接口修改，所以修改默认常量导出，改为类获取
 */

import { env, isProduction } from "../../env";

class ModuleServiceUrl {
  static _gwCtsUrl = `//gw.api.ddxq.mobi`; // 经过网关的cts服务域名

  static _ctsUrl = `${this._gwCtsUrl}/cts-service`;
  static defaultUrl = "";

  // 得到最新的请求地址,新的服务接口需要加/cts-service
  static setCtsUrl() {
    if (isProduction) {
      ModuleServiceUrl._ctsUrl = ModuleServiceUrl._gwCtsUrl + "/cts-service";
    } else {
      ModuleServiceUrl._ctsUrl =
        `//gw.api.${env}.dingdongxiaoqu.com` + "/cts-service";
    }
  }

  // 获取cts的服务域名
  static getCtsUrl() {
    return ModuleServiceUrl._ctsUrl;
  }

  // 判断得到cts最终使用的服务名
  static async judgeCtsServiceUrl() {
    ModuleServiceUrl.setCtsUrl();
  }
}

export default ModuleServiceUrl;
